import { render } from "./AcceptInvitationWithToken.vue?vue&type=template&id=9e59c87c"
import script from "./AcceptInvitationWithToken.vue?vue&type=script&lang=js"
export * from "./AcceptInvitationWithToken.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__